








import { Component, Vue } from 'vue-property-decorator';

import AppContainerComponent from '@/components/AppContainerComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';
import { siteConfig } from '@/SiteConfig.ts';

@Component({
  components: {
    FooterComponent,
    AppContainerComponent
  },
})
export default class Home extends Vue {
  private imgLink = siteConfig.imgLink;
  private title = siteConfig.title;

  private getImgUrl(pic: string) {
    return require('../assets/' + pic);
  }
}
